import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { isParentPortalSession } from "./studentSupportApiPayload";

/** Support tickets are parent-portal only (not direct student login). */
function StudentSupportParentGuard({ children }) {
  const navigate = useNavigate();
  const isParent = isParentPortalSession();

  useEffect(() => {
    if (!isParent) {
      toast.info(
        "Support tickets are available to parents only. Sign in with your parent portal account.",
        { position: toast.POSITION.TOP_RIGHT }
      );
      navigate("/student-panel/dashboard", { replace: true });
    }
  }, [isParent, navigate]);

  if (!isParent) {
    return null;
  }

  return children;
}

export default StudentSupportParentGuard;
